@if (debouncedLoading | async) {
  <div class="p-4 md:p-12 flex justify-center items-center w-full">
    <div class="flex space-x-2">
      <app-loading></app-loading>
    </div>
  </div>
} @else {
  @if (itemNotFound | async) {
    <div class="p-4 md:p-12">
      <div class="flex flex-row items-center mb-6">
        <ng-icon name="heroFaceFrown" size="32px" class="mr-4 text-red-600"></ng-icon>
        <h1 class="mb-0">{{ { key: 'couldNotLoadItem' } | i18n }}</h1>
      </div>

      <p>{{ { key: 'couldNotLoadItemInfo' } | i18n }}</p>

      <div class="sm:flex-col1 mt-12 flex">
        <button
          class="flex max-w-xs flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-3 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50 sm:w-full"
          [routerLink]="'/shop'"
        >
          {{ { key: 'backToShop' } | i18n }}
        </button>
      </div>
    </div>
  } @else {
    @if (mainItemSubject | async; as mainItem) {
      @if (selectedItemSubject | async; as selectedItem) {
        <div class="bg-white w-full relative">
          <div
            class="bg-white flex-col border-b mb-12 border-gray-200 header-background py-1 sticky top-[142px] z-50 justify-center h-16 hidden md:flex"
            #infoBox
          >
            <div class="flex flex-row text-xs">
              @for (b of breadcrumbs | async; track b; let i = $index) {
                <a (click)="breadcrumbClicked(b)" class="hover:text-primary-700 text-gray-700 cursor-pointer">
                  {{ b.text | i18n }}
                  @if (i !== ((breadcrumbs | async) || []).length - 1) {
                    <span class="text-gray-400"> &nbsp;>&nbsp; </span>
                  }
                </a>
              }
            </div>
            @if (showInfoBoxTitle | async) {
              <div class="mt-1 font-bold">{{ { object: mainItem.designation } | i18n }}</div>
            }
          </div>
          @if (selectedMetaSubject | async; as meta) {
            <div class="mx-auto">
              <div class="lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
                <app-image-slider [items]="imagesAndVideos()" [enableOverlay]="true"></app-image-slider>

                <div class="mt-10 sm:mt-16 lg:mt-0">
                  <h1 class="text-3xl font-bold tracking-tight text-gray-900 mb-0" #itemTitle>
                    {{ { object: mainItem.designation } | i18n }}
                  </h1>
                  <div class="flex flex-row justify-between text-sm text-gray-500 mt-2 mb-6">
                    <span>
                      {{ selectedItem.itemNumber }}
                    </span>
                    <span>
                      @if (
                        meta.price.pricePerUnit?.unit &&
                        meta.price.pricePerStockKeepingUnit?.unit &&
                        meta.price.pricePerUnit?.unit !== meta.price.pricePerStockKeepingUnit?.unit
                      ) {
                        {{ meta.price.pricePerUnit | bbitFormatUnit }} à {{ meta.price.pricePerStockKeepingUnit | bbitFormatUnit }}
                      }
                    </span>
                  </div>

                  @if (mainItemSubject | async; as mainItem) {
                    @if (mainMetaSubject | async; as mainMeta) {
                      @if (mainItem.itemType === '#productGroup') {
                        @for (attributeId of keys(mainMeta.attributeConfiguration || {}); track attributeId) {
                          <div class="mt-4 mb-4">
                            <p class="text-sm font-bold">
                              {{ mainMeta.attributeTranslations?.[attributeId] || '' | i18n }}
                            </p>
                            <div class="grid grid-cols-3 gap-2 mb-4">
                              @for (config of mainMeta.attributeConfiguration?.[attributeId] | itemAttributeSort; track config._id) {
                                @if (isAttributeAvailable(attributeId, config._id)) {
                                  <button
                                    (click)="selectAttribute(attributeId, config._id)"
                                    class="col-span-1 p-4 rounded-md border-2 border-gray-300 flex items-center justify-center"
                                    [class.border-primary-600]="(selectedAttributes | async)?.[attributeId] === config._id"
                                  >
                                    <div class="text-base">
                                      {{ config.text | i18n }}
                                    </div>
                                  </button>
                                }
                              }
                            </div>
                          </div>
                        }
                      }
                    }
                  }

                  <div class="mt-3 flex flex-row w-full items-end justify-between">
                    <p class="mb-3">
                      <app-item-stock [stock]="meta.stock"></app-item-stock>
                    </p>
                    <p class="text-3xl tracking-tight text-gray-900 text-right">
                      <app-item-price [price]="meta.price"></app-item-price>
                    </p>
                  </div>

                  <div class="mt-6">
                    @if ((meta?.price?.graduatedPrices || []).length > 0) {
                      <div class="grid grid-cols-3 gap-2">
                        @for (p of meta.price.graduatedPrices; track p) {
                          <button
                            class="border-2 border-gray-300 rounded-md text-sm p-2"
                            (click)="itemsToAdd.next(p.quantity.amount || 1)"
                            [class.border-primary-600]="$any(p).isActive"
                          >
                            <div class="mb-2 text-gray-500 text-xs">
                              {{
                                {
                                  key: 'fromXUnit',
                                  values: [p.quantity | bbitFormatUnit],
                                  n: p.quantity.amount,
                                } | i18n
                              }}
                            </div>
                            <div class="mb-2 font-bold">
                              <div>
                                @if (cart.observeIsVatInclusive() | async) {
                                  {{ p.priceInclVat | bbitFormatPrice }}
                                } @else {
                                  {{ p.priceExclVat | bbitFormatPrice }}
                                }
                              </div>
                            </div>

                            <div class="text-red-600">{{ p.discount?.amount || 0 }}%</div>
                          </button>
                        }
                      </div>
                    }

                    @if (selectedMetaSubject | async; as currentMeta) {
                      @if ((currentMeta?.requiredPermits?.length || 0) > 0) {
                        <div class="text-sm mt-4 mb-4 flex flex-col w-full bg-primary-100 border-2 border-black rounded-md p-4">
                          <p class="font-bold">
                            {{
                              {
                                key: 'requiredPermitsText',
                                n: currentMeta?.requiredPermits?.length,
                              } | i18n
                            }}
                          </p>
                          <ul class="ml-4 list-disc">
                            @for (permit of currentMeta.requiredPermits; track permit._id) {
                              <li>
                                {{ permit.text | i18n }}
                              </li>
                            }
                          </ul>
                        </div>
                      }
                    }

                    @if (meta.canBeSold) {
                      <div class="sm:flex-col1 mt-4 flex flex-row w-full">
                        <app-quantity-input
                          [quantity]="itemsToAdd | async"
                          (quantityChange)="itemsToAdd.next($event)"
                          [stock]="meta.stock"
                        ></app-quantity-input>

                        <button
                          class="ml-2 w-full flex flex-1 items-center justify-center rounded-md border border-transparent bg-primary-600 py-3 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 focus:ring-offset-gray-50"
                          (click)="cart.addPosition(selectedItem._id, itemsToAdd.value)"
                        >
                          {{ { key: 'addToCart' } | i18n }}
                        </button>
                      </div>
                    }
                  </div>
                </div>
              </div>
              @if (mainItem.description | bbitRichTextI18n; as description) {
                <div class="mt-12 border-t border-primary-600">
                  <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">{{ { key: 'description' } | i18n }}</h2>
                  <div class="space-y-6 text-base p-4">
                    <app-read-more [html]="description"></app-read-more>
                  </div>
                </div>
              }

              @if (technicalData | async; as td) {
                @if (td.length > 0) {
                  <div class="mt-12 border-t border-primary-600">
                    <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">{{ { key: 'technicalData' } | i18n }}</h2>
                    <div class="grid grid-cols-2 gap-4 p-4">
                      @for (o of td; track o.text; let i = $index) {
                        @if (i < 3 || showAllTechnicalData()) {
                          <div class="font-bold">{{ o.text }}</div>
                          <div class="text-gray-600">{{ o.value }}</div>
                        }
                      }
                    </div>
                    @if (td.length > 3) {
                      <button (click)="showAllTechnicalData.set(!showAllTechnicalData())" class="mt-4 p-4 text-primary-600 text-sm">
                        {{ !showAllTechnicalData() ? ({ key: 'showMore' } | i18n) : ({ key: 'showLess' } | i18n) }}...
                      </button>
                    }
                  </div>
                }
              }

              @if (mainItem.scopeOfDeliveryDescription | bbitRichTextI18n; as scopeOfDelivery) {
                <div class="mt-12 border-t border-primary-600">
                  <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">{{ { key: 'scopeOfDelivery' } | i18n }}</h2>
                  <div class="space-y-6 text-base p-4">
                    <app-read-more [html]="scopeOfDelivery"></app-read-more>
                  </div>
                </div>
              }

              @if (downloads | async; as dls) {
                @if (dls.length > 0) {
                  <div class="mt-12 border-t border-primary-600">
                    <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">Downloads</h2>
                    <div class="mb-6 p-4">
                      @for (o of dls; track o.url) {
                        <a
                          [download]="o.fileName"
                          [href]="o.url"
                          target="_blank"
                          class="w-full flex flex-row justify-between border-b last:border-b-0 p-4 hover:bg-primary-600 hover:bg-opacity-5"
                        >
                          <div>{{ o.designation | i18n }}</div>
                          <ng-icon name="heroArrowDownTray" size="24px" class="text-gray-400"></ng-icon>
                        </a>
                      }
                    </div>
                  </div>
                }
              }

              @if (accessories | async; as acs) {
                @if (acs.length > 0) {
                  <div class="mt-12 border-t border-primary-600">
                    <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">{{ { key: 'accessories' } | i18n }}</h2>
                    <div class="mb-6 p-4">
                      @for (o of acs; track o._id) {
                        <a
                          [routerLink]="['/', 'shop', 'item', o._slug ? o._slug : o._id]"
                          class="border-b last:border-b-0 p-4 flex flex-col hover:bg-primary-600 hover:bg-opacity-5"
                        >
                          <div class="grid gap-x-4 gap-y-4 grid-cols-6 md:grid-cols-12">
                            @if (api.observeItemImage(o._id) | async; as variantImage) {
                              <div class="col-span-2">
                                <picture
                                  [bbitPictureSrc]="variantImage.url"
                                  [bbitPictureDefaultSize]="300"
                                  [bbitPictureImgClasses]="'h-full w-full object-scale-down object-center sm:h-full sm:w-full'"
                                  [bbitPictureAlt]="variantImage.alt"
                                ></picture>
                              </div>
                            }

                            <div class="col-span-4 md:col-span-6 flex items-center">
                              @if (api.observeItemDesignation(o._id) | async; as d) {
                                {{ { object: d } | i18n }}
                              }
                            </div>

                            <div class="col-span-6 md:col-span-4 flex items-center justify-between">
                              <app-item-stock [stock]="o.stock"></app-item-stock>
                              <app-item-price [price]="o.price"></app-item-price>
                            </div>
                          </div>
                        </a>
                      }
                    </div>
                  </div>
                }
              }

              @if (crossSellingItems | async; as csi) {
                @if (csi.length > 0) {
                  <div class="mt-12 border-t border-primary-600">
                    <h2 class="mb-6 font-bold w-full p-4 bg-primary-600 bg-opacity-5">{{ { key: 'matchingProducts' } | i18n }}</h2>
                    <div class="mb-6 p-4">
                      @for (o of csi; track o._id) {
                        <a
                          [routerLink]="['/', 'shop', 'item', o._slug ? o._slug : o._id]"
                          class="border-b last:border-b-0 p-4 flex flex-col hover:bg-primary-600 hover:bg-opacity-5"
                        >
                          <div class="grid gap-x-4 gap-y-4 grid-cols-6 md:grid-cols-12">
                            @if (api.observeItemImage(o._id) | async; as variantImage) {
                              <div class="col-span-2">
                                <picture
                                  [bbitPictureSrc]="variantImage.url"
                                  [bbitPictureDefaultSize]="300"
                                  [bbitPictureImgClasses]="'h-full w-full object-scale-down object-center sm:h-full sm:w-full'"
                                  [bbitPictureAlt]="variantImage.alt"
                                ></picture>
                              </div>
                            }

                            <div class="col-span-4 md:col-span-6 flex items-center">
                              @if (api.observeItemDesignation(o._id) | async; as d) {
                                {{ { object: d } | i18n }}
                              }
                            </div>

                            <div class="col-span-6 md:col-span-4 flex items-center justify-between">
                              <app-item-stock [stock]="o.stock"></app-item-stock>
                              <app-item-price [price]="o.price"></app-item-price>
                            </div>
                          </div>
                        </a>
                      }
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
    }
  }
}
